<template>
  <div>
    <Banner :classType="3" />
    <AboutMenu v-if="lang=='en'"
      :menu="[
        { name: 'COMPANY NEWS', url: '/news/company' },
      ]"
    />
    <AboutMenu v-else
      :menu="[
        { name: '公司动态', url: '/news/company' },
      /*   { name: '文化活动', url: '/news/culture' }, */
        { name: '视频新闻', url: '/news/video' },
        { name: '行业动态', url: '/news/industry' },
        { name: '信息公示', url: '/news/infomation' },
        { name: '企业内刊', url: '/news/magazine' },
      ]"
    />
   
    <div class="pageTitle wow animate__slideInUp" :class="{ titleEn: lang == 'en' }">
      <h2>{{ titleObj[type].name }}</h2>
      <p>{{ titleObj[type].enName }}</p>
    </div>

    <div class="wrap wow animate__slideInUp" v-if="type == 'company'">
      <Slide :TopNewsInfos="TopNewsInfos"  :lang="lang"/>
    </div>

    <div
      class="newsMG wrap"
      v-show="
        type == 'company' ||
        type == 'culture' ||
        type == 'industry' ||
        type == 'infomation'
      "
    >
      <div class="newsBox"><NewsList :newsList="newsList" :lang="lang"/></div>
      <div class="pageBox" v-if="showPage">
        <Pagination @pageChange="getNewsList" :PagingInfo="PagingInfo" />
      </div>
    </div>

    <div class="wrap wow animate__slideInUp" v-if="type == 'video'">
      <VideoList :videoList="videoList" />
      <div class="pageBox">
        <Pagination @pageChange="getVideoList" :PagingInfo="PagingInfoV" />
      </div>
    </div>

    <div class="wrap" v-if="type == 'magazine'">
      <BookList :bookList="bookList" />
      <div class="pageBox">
        <Pagination @pageChange="getBookList" :PagingInfo="PagingInfoB" />
      </div>
    </div>
  </div>
</template>

<script>
import AboutMenu from "./components/AboutMenu";
import NewsList from "./components/NewsList";
import Slide from "./components/Slide";
import VideoList from "./components/VideoList";
import BookList from "./components/BookList";
import { WOW } from "wowjs";
import Pagination from "@/views/components/Pagenation";
import Banner from "@/views/components/Banner";

export default {
  data() {
    return {
      type: this.$route.query.type || "company",
      lang: this.$global.lang,
      titleObj: {
        company: { name: "公司动态", enName: "COMPANY NEWS" },
        culture: { name: "文化活动", enName: "CULTURAL EVENTS" },
        video: { name: "视频新闻", enName: "VIDEO NEWS" },
        industry: { name: "行业动态", enName: "INDUSTRY NEWS" },
        infomation: { name: "信息公示", enName: "INFORMATION PUBLICITY" },
        magazine: { name: "企业内刊", enName: "ENTERPRISE JOURNAL" },
      },
      TopNewsInfos: [],
      newsList: [],
      newsType: "",
      videoList: [],
      bookList: [],
      PagingInfo: {},
      PagingInfoV: {},
      PagingInfoB: {},
      pageCur: 1,
      showPage: false,
    };
  },
  components: {
    AboutMenu,
    NewsList,
    Slide,
    VideoList,
    BookList,
    Pagination,
    Banner,
  },
  methods: {
    getNewsList(page, type) {
      this.$api
        .newsList({
          Type: this.newsType,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { NewsItems, PagingInfo } = res.Value;
          this.newsList = NewsItems;
          this.PagingInfo = PagingInfo;
          this.showPage = true
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    changeNewsType() {
      switch (this.type) {
        case "company":
          this.newsType = 1;
          break;
        case "culture":
          this.newsType = 2;
          break;
        case "industry":
          this.newsType = 3;
          break;
        case "infomation":
          this.newsType = 4;
          break;
      }
    },
    getVideoList(page, type) {
      this.$api
        .videoList({
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { Videos, PagingInfo } = res.Value;
          this.videoList = Videos;
          this.PagingInfoV = PagingInfo;
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    getBookList(page, type) {
      this.$api
        .bookList({
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { EnterpriseJournalInfos, PagingInfo } = res.Value;
          this.bookList = EnterpriseJournalInfos;
          this.PagingInfoB = PagingInfo;
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    getTopNewsList() {
      this.$api
        .topNewsList({
          Type: "1",
        })
        .then((res) => {
          const { TopNewsInfos } = res.Value;
          this.TopNewsInfos = TopNewsInfos;
        });
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        this.changeNewsType();
        if (this.type == "video") {
          this.getVideoList(1, "first");
        } else if (this.type == "magazine") {
          this.getBookList(1, "first");
        } else {
          if (this.type == "company") {
            this.getTopNewsList(1, "first");
          }
          this.getNewsList(1, "first");
        }
      }
    );
  },
  beforeRouteEnter(to, from, next) {
    let fromURL = from.name;
    next((vm) => {
      if (fromURL == "newsContent")
        vm.pageCur = sessionStorage.getItem("currentPage");
    });
  },
  mounted() {
    this.type = this.$route.params.type;
    if (this.type == "company") {
      this.$api
        .topNewsList({
          Type: "1",
        })
        .then((res) => {
          const { TopNewsInfos } = res.Value;
          this.TopNewsInfos = TopNewsInfos;
          /* this.$nextTick(() => {
            new WOW({
              boxClass: "wow",
              animateClass: "animate__animated",
              live: false,
            }).init();
          }); */
        });
    }

    this.changeNewsType();

    if (this.type == "video") {
      this.getVideoList(1, "first");
    } else if (this.type == "magazine") {
      this.getBookList(this.pageCur, "first");
    } else {
      this.getNewsList(this.pageCur, "first");
    }
  },
};
</script>

<style lang="scss">
.newsMG {
  margin: 50px 0 0 0;
  .newsBox {
    overflow: hidden;
    padding-top: 30px;
  }
}
</style>